import React, { Component } from 'react';
import { Card, message } from 'antd';
import Process from '@comm/workflow/Process';

import { connect } from 'react-redux';
import { getExpendType } from '@store/modules/finance/expend_type';
import { getCompanyList } from '@store/modules/company_list';
import Modalshortfalls from '@comm/shortfalls';

import { queryPaymentWorkflow, querySavePayment } from '@api/finance/payment';
import FormBase from './FormBase';

class Page extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataInfo: {},
      company: [],
      isSubmitting: false,
      instance: {
        activities: [],
        currentActivity: {},
      },
      shortData: '',
      visible: false,
    };
  }

  componentDidMount() {
    const { dataInfo } = this.state;
    this.setState({ dataInfo });
    this.paymentWorkflow();
    const { dispatch } = this.props;
    dispatch(getExpendType());
    dispatch(getCompanyList());
  }

  /**
   * 提交付款
   */
  handSubmit = item => {
    this.savePayment(item);
  };

  paymentWorkflow = params => {
    const { instance } = this.state;
    queryPaymentWorkflow(params).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          instance: {
            ...instance,
            activities: res.data,
          },
        });
      }
    });
  };

  /**
   * 保存
   */
  savePayment = item => {
    this.setState({
      isSubmitting: true,
    });
    querySavePayment(item).then(res => {
      this.setState({
        isSubmitting: false,
      });
      if (res.statusCode === 200) {
        message.success(res.message);
        this.props.router.go(-1);
      } else if (res.message.indexOf('\n') === -1) {
        message.error(res.message);
      } else {
        this.setState({
          shortData: res.message,
          visible: true,
        });
      }
    });
  };

  hideModal = () => {
    this.setState({
      visible: false,
    });
  };

  render() {
    const { isSubmitting, instance, shortData, visible } = this.state;
    return (
      <div>
        <FormBase
          data={this.state.dataInfo}
          company={this.state.company}
          handSubmit={this.handSubmit}
          isSubmitting={isSubmitting}
          {...this.props}
        />
        <Card>
          <Process instance={instance} />
        </Card>
        <Modalshortfalls data={shortData || ''} visible={visible} hideModal={this.hideModal} />
      </div>
    );
  }
}

export default connect(state => ({
  expendType: state.expend_type,
  company: state.company_list,
}))(Page);



// WEBPACK FOOTER //
// ./src/components/finance/payment/PageAdd.js